<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <div class="group-layout">
          <!-- 左侧分组 -->
          <div class="group-sidebar">
            <div class="sidebar-header">
              <h3>客户分组</h3>
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="addGroup">新建</el-button>
            </div>
            <el-input
              v-model="groupKeyword"
              size="small"
              clearable
              placeholder="搜索分组"
              prefix-icon="el-icon-search"
              class="group-search"
              @keyup.enter.native="loadGroups"
              @clear="loadGroups">
            </el-input>
            <div class="group-list" v-loading="groupLoading">
              <div
                v-for="item in groupList"
                :key="item.id"
                class="group-item"
                :class="{ active: selectedGroup && selectedGroup.id === item.id }"
                @click="selectGroup(item)">
                <div class="group-item-title">{{ item.group_name || item.display_name || '未命名分组' }}</div>
                <div class="group-item-meta">
                  <el-tag size="mini" :type="item.group_status === '1' ? 'success' : 'info'">
                    {{ item.group_status === '1' ? '启用' : '禁用' }}
                  </el-tag>
                  <span v-if="item.discount">折扣 {{ item.discount }}</span>
                </div>
              </div>
              <div v-if="!groupLoading && groupList.length === 0" class="empty-tip">暂无分组</div>
            </div>
          </div>

          <!-- 右侧成员 -->
          <div class="group-main">
            <div class="main-header" v-if="selectedGroup">
              <div>
                <h3>{{ selectedGroup.group_name || selectedGroup.display_name }}</h3>
                <p class="main-desc">{{ selectedGroup.description || '暂无描述' }}</p>
              </div>
              <div class="main-actions">
                <el-button size="mini" icon="el-icon-edit" @click="editGroup(selectedGroup)">编辑分组</el-button>
                <el-button size="mini" type="primary" icon="el-icon-plus" @click="openAddMember">添加成员</el-button>
                <el-popconfirm title="确定删除该分组吗？" @confirm="deleteGroup(selectedGroup.id)">
                  <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete">删除分组</el-button>
                </el-popconfirm>
              </div>
            </div>
            <div v-else class="empty-main">请选择左侧分组查看成员</div>

            <el-table
              v-if="selectedGroup"
              :data="memberList"
              v-loading="memberLoading"
              border
              stripe
              empty-text="该分组暂无成员">
              <el-table-column type="index" width="60" label="序号" />
              <el-table-column prop="customer_email" label="邮箱" min-width="180" />
              <el-table-column prop="customer_id" label="客户ID" min-width="220" show-overflow-tooltip />
              <el-table-column label="状态" width="100">
                <template slot-scope="scope">
                  {{ memberStatusText(scope.row.group_user_status) }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-popconfirm title="确定移除该成员吗？" @confirm="removeMember(scope.row)">
                    <el-button slot="reference" type="text" style="color:#f56c6c">移除</el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </PageHeaderLayout>

    <!-- 新建/编辑分组 -->
    <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="groupForm" label-position="right" label-width="96px">
          <el-form-item label="组名称" prop="group_name">
            <el-input v-model="formData.group_name" placeholder="请输入组名称"></el-input>
          </el-form-item>
          <el-form-item label="显示名称" prop="display_name">
            <el-input v-model="formData.display_name" placeholder="请输入显示名称"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input type="textarea" :rows="3" v-model="formData.description"></el-input>
          </el-form-item>
          <el-form-item label="折扣" prop="discount">
            <el-input v-model="formData.discount" type="number" placeholder="例如 1 表示无折扣"></el-input>
          </el-form-item>
          <el-form-item label="使用折扣" prop="use_discount">
            <el-switch v-model="formData.use_discount" :active-value="'1'" :inactive-value="'0'" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </el-form-item>
          <el-form-item label="状态" prop="group_status">
            <el-switch v-model="formData.group_status" :active-value="'1'" :inactive-value="'0'" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
          </el-form-item>
        </el-form>
      </template>
    </ApeDrawer>

    <!-- 添加成员 -->
    <el-dialog title="添加成员" :visible.sync="memberDialogVisible" width="720px" @open="loadCandidateCustomers">
      <el-input
        v-model="customerKeyword"
        size="small"
        clearable
        placeholder="搜索邮箱/用户名"
        prefix-icon="el-icon-search"
        style="margin-bottom: 12px;"
        @keyup.enter.native="loadCandidateCustomers">
      </el-input>
      <el-table
        ref="candidateTable"
        :data="candidateList"
        v-loading="candidateLoading"
        border
        height="360"
        @selection-change="onCandidateSelectionChange">
        <el-table-column type="selection" width="50" />
        <el-table-column prop="username" label="用户名" min-width="120" />
        <el-table-column prop="email" label="邮箱" min-width="180" />
        <el-table-column prop="country" label="国家" width="100" />
      </el-table>
      <span slot="footer">
        <el-button @click="memberDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addingMembers" @click="confirmAddMembers">确认添加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeDrawer from '@/components/ApeDrawer'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer
  },
  data() {
    return {
      groupKeyword: '',
      groupLoading: false,
      groupList: [],
      selectedGroup: null,
      memberLoading: false,
      memberList: [],
      formData: {},
      rules: {
        group_name: [{ required: true, message: '请输入组名称', trigger: 'blur' }],
        display_name: [{ required: true, message: '请输入显示名称', trigger: 'blur' }]
      },
      drawerData: {
        visible: false,
        loading: false,
        loading_text: '玩命加载中……',
        title: '新建分组',
        width_height: '520px'
      },
      memberDialogVisible: false,
      customerKeyword: '',
      candidateLoading: false,
      candidateList: [],
      selectedCandidates: [],
      addingMembers: false
    }
  },
  methods: {
    memberStatusText(status) {
      const map = { '0': '未处理', '1': '已加入', '2': '已拒绝' }
      return map[String(status)] || '-'
    },
    async loadGroups() {
      this.groupLoading = true
      const payload = {
        current_page: 1,
        page_size: 200,
        query: '',
        params: [],
        order_by: 'created_at desc'
      }
      if (this.groupKeyword) {
        payload.query = 'instr(group_name,?)>0'
        payload.params = [this.groupKeyword]
      }
      const res = await this.$api.post('/service/ola_app_customer_group/list', payload)
      if (this.$apiSuccess(res)) {
        this.groupList = res.data.list || []
        if (this.selectedGroup) {
          const found = this.groupList.find(g => g.id === this.selectedGroup.id)
          if (found) {
            this.selectedGroup = found
          } else if (this.groupList.length) {
            this.selectGroup(this.groupList[0])
          } else {
            this.selectedGroup = null
            this.memberList = []
          }
        } else if (this.groupList.length) {
          this.selectGroup(this.groupList[0])
        }
      } else {
        this.$message.error(res.message || '加载分组失败')
      }
      this.groupLoading = false
    },
    selectGroup(group) {
      this.selectedGroup = group
      this.loadMembers()
    },
    async loadMembers() {
      if (!this.selectedGroup) {
        this.memberList = []
        return
      }
      this.memberLoading = true
      const res = await this.$api.post('/service/ola_app_customer_group_user/list', {
        current_page: 1,
        page_size: 500,
        query: 'customer_group_id=?',
        params: [this.selectedGroup.id]
      })
      if (this.$apiSuccess(res)) {
        this.memberList = res.data.list || []
      } else {
        this.memberList = []
        this.$message.error(res.message || '加载成员失败')
      }
      this.memberLoading = false
    },
    addGroup() {
      this.formData = {
        group_name: '',
        display_name: '',
        description: '',
        discount: 1,
        use_discount: '0',
        group_status: '1'
      }
      this.drawerData.title = '新建分组'
      this.drawerData.visible = true
      this.drawerData.loading = false
    },
    editGroup(group) {
      this.formData = {
        ...group,
        use_discount: group.use_discount != null ? String(group.use_discount) : '0',
        group_status: group.group_status != null ? String(group.group_status) : '1'
      }
      this.drawerData.title = '编辑分组'
      this.drawerData.visible = true
      this.drawerData.loading = false
    },
    drawerClose() {
      this.drawerData.visible = false
      this.formData = {}
    },
    drawerConfirm() {
      this.$refs.groupForm.validate(async (valid) => {
        if (!valid) {
          this.$message.error('请检查必填项')
          return
        }
        this.drawerData.loading = true
        const payload = { ...this.formData }
        delete payload.created_at
        delete payload.updated_at
        const isCreate = !payload.id
        const url = isCreate
          ? '/service/ola_app_customer_group/create'
          : '/service/ola_app_customer_group/update'
        const res = await this.$api.post(url, payload)
        this.drawerData.loading = false
        if (this.$apiSuccess(res)) {
          this.$message.success('保存成功')
          this.drawerData.visible = false
          await this.loadGroups()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      })
    },
    async deleteGroup(id) {
      // 先清理分组成员，避免残留关联
      const members = Array.isArray(this.memberList) ? this.memberList.slice() : []
      for (const m of members) {
        if (!m || !m.id) continue
        await this.$api.post('/service/ola_app_customer_group_user/delete', { id: m.id })
      }
      const res = await this.$api.post('/service/ola_app_customer_group/delete', { id })
      if (this.$apiSuccess(res)) {
        this.$message.success('删除成功')
        this.selectedGroup = null
        this.memberList = []
        await this.loadGroups()
      } else {
        this.$message.error(res.message || '删除失败')
      }
    },
    openAddMember() {
      if (!this.selectedGroup) {
        this.$message.warning('请先选择分组')
        return
      }
      this.customerKeyword = ''
      this.selectedCandidates = []
      this.memberDialogVisible = true
    },
    async loadCandidateCustomers() {
      this.candidateLoading = true
      const memberIds = new Set((this.memberList || []).map(m => m.customer_id))
      const payload = {
        current_page: 1,
        page_size: 200,
        query: '',
        params: []
      }
      if (this.customerKeyword) {
        payload.query = 'instr(email,?)>0'
        payload.params = [this.customerKeyword]
      }
      const res = await this.$api.post('/service/ola_app_customer/list', payload)
      if (this.$apiSuccess(res)) {
        const list = res.data.list || []
        this.candidateList = list.filter(c => !memberIds.has(c.id))
      } else {
        this.candidateList = []
        this.$message.error(res.message || '加载客户失败')
      }
      this.candidateLoading = false
    },
    onCandidateSelectionChange(rows) {
      this.selectedCandidates = rows || []
    },
    async confirmAddMembers() {
      if (!this.selectedCandidates.length) {
        this.$message.warning('请勾选要添加的客户')
        return
      }
      this.addingMembers = true
      let ok = 0
      let fail = 0
      for (const customer of this.selectedCandidates) {
        const res = await this.$api.post('/service/ola_app_customer_group_user/create', {
          customer_group_id: this.selectedGroup.id,
          customer_id: customer.id,
          customer_email: customer.email || '',
          group_user_status: '1',
          customer_type: '0'
        })
        if (this.$apiSuccess(res)) {
          ok++
        } else {
          fail++
        }
      }
      this.addingMembers = false
      if (ok) {
        this.$message.success(`成功添加 ${ok} 人` + (fail ? `，失败 ${fail} 人` : ''))
        this.memberDialogVisible = false
        await this.loadMembers()
      } else {
        this.$message.error('添加失败')
      }
    },
    async removeMember(row) {
      const res = await this.$api.post('/service/ola_app_customer_group_user/delete', { id: row.id })
      if (this.$apiSuccess(res)) {
        this.$message.success('已移除')
        await this.loadMembers()
      } else {
        this.$message.error(res.message || '移除失败')
      }
    }
  },
  mounted() {
    this.loadGroups()
  }
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 16px
  min-height calc(100vh - 84px)
  background #f5f7fa

.group-layout
  display flex
  gap 16px
  min-height 640px

.group-sidebar
  width 280px
  flex-shrink 0
  background #fff
  border-radius 8px
  border 1px solid #e8ecf4
  padding 12px
  display flex
  flex-direction column

.sidebar-header
  display flex
  align-items center
  justify-content space-between
  margin-bottom 12px
  h3
    margin 0
    font-size 16px

.group-search
  margin-bottom 12px

.group-list
  flex 1
  overflow-y auto

.group-item
  padding 10px 12px
  border-radius 6px
  cursor pointer
  margin-bottom 6px
  border 1px solid transparent
  &:hover
    background #f5f7fa
  &.active
    background #ecf5ff
    border-color #b3d8ff

.group-item-title
  font-weight 600
  color #303133
  margin-bottom 6px

.group-item-meta
  display flex
  align-items center
  gap 8px
  font-size 12px
  color #909399

.group-main
  flex 1
  background #fff
  border-radius 8px
  border 1px solid #e8ecf4
  padding 16px

.main-header
  display flex
  justify-content space-between
  align-items flex-start
  margin-bottom 16px
  h3
    margin 0 0 4px 0
  .main-desc
    margin 0
    color #909399
    font-size 13px

.main-actions
  display flex
  gap 8px
  flex-wrap wrap

.empty-tip, .empty-main
  color #909399
  text-align center
  padding 40px 12px
</style>
